import { Component, Inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ExportRequestService } from '../../services/ExportRequestService/export-request';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

export interface DeclineExportRequestDialogData {
  exportRequestId: string;
}

@Component({
  selector: 'app-decline-export-request-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ErrorBanner,
  ],
  templateUrl: './decline-export-request-dialog.html',
  styleUrl: './decline-export-request-dialog.scss',
})
export class DeclineExportRequestDialog {
  reason = '';
  isSubmitting = signal(false);
  errorMessage = signal('');

  constructor(
    private dialogRef: MatDialogRef<DeclineExportRequestDialog>,
    private exportRequestService: ExportRequestService,
    @Inject(MAT_DIALOG_DATA) private data: DeclineExportRequestDialogData
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.reason.trim()) {
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');

    this.exportRequestService.decline(this.data.exportRequestId, this.reason).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.isSubmitting.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to decline export request.'));
      },
    });
  }
}
